module.exports = __webpack_public_path__ + "media/images/top/img_pickup_kohaku-c5ffb6c1c40a2bf6d74d65be217258f5.webp";